module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list recruit-train-stat-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("招聘培训统计")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "stat-toolbar"
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "value": _vm.dateRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": false,
      "disabled": _vm.searchLoading,
      "transfer": "",
      "placeholder": "选择日期范围"
    },
    on: {
      "on-change": _vm.onDateRangeChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hr-label"
  }, [_vm._v("统计模板")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "transfer": "",
      "disabled": _vm.searchLoading
    },
    on: {
      "on-change": _vm.onStatTemplateChange
    },
    model: {
      value: (_vm.statTemplate),
      callback: function($$v) {
        _vm.statTemplate = $$v
      },
      expression: "statTemplate"
    }
  }, [_c('Option', {
    attrs: {
      "value": "default"
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "agency"
    }
  }, [_vm._v("按中介")])], 1), _vm._v(" "), _c('span', {
    staticClass: "hr-label"
  }, [_vm._v("HR")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": "",
      "disabled": _vm.searchLoading
    },
    on: {
      "on-change": _vm.onHrChange
    },
    model: {
      value: (_vm.hr),
      callback: function($$v) {
        _vm.hr = $$v
      },
      expression: "hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "stat-formula"
  }, [_vm._v("注册人数 = 待审核 + 已审核 + 培训中 + 培训淘汰 + 培训流失 + 在职人数 + 离职人数 + 已禁用")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.summaryColumns,
      "data": _vm.summaryData,
      "loading": _vm.tableLoading,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("按注册渠道")]), _vm._v(" "), _c('Table', {
    ref: "channelTable",
    attrs: {
      "height": _vm.channelTableHeight,
      "columns": _vm.channelColumns,
      "data": _vm.channelTableData,
      "loading": _vm.tableLoading,
      "row-class-name": _vm.channelRowClassName,
      "border": "",
      "stripe": ""
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.detailTitle,
      "width": "800"
    },
    model: {
      value: (_vm.detailVisible),
      callback: function($$v) {
        _vm.detailVisible = $$v
      },
      expression: "detailVisible"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.detailColumns,
      "data": _vm.detailData,
      "loading": _vm.detailLoading,
      "border": "",
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-page"
  }, [_c('Page', {
    attrs: {
      "total": _vm.detailTotal,
      "current": _vm.detailPageIndex,
      "page-size": _vm.detailPageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onDetailPageChange,
      "on-page-size-change": _vm.onDetailPageSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a804e512","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchRecruitTrainStat.vue
// module id = 1943
// module chunks = 8